export default {
  'app.setting.pagestyle': 'Настройка стиля страницы',
  'app.setting.pagestyle.dark': 'Темный стиль',
  'app.setting.pagestyle.light': 'Светлый стиль',
  'app.setting.content-width': 'Ширина содержимого',
  'app.setting.content-width.fixed': 'Фиксированная',
  'app.setting.content-width.fluid': 'Резиновая',
  'app.setting.themecolor': 'Цвет темы',
  'app.setting.themecolor.dust': 'Пыльно-красный',
  'app.setting.themecolor.volcano': 'Вулканический',
  'app.setting.themecolor.sunset': 'Закатно-оранжевый',
  'app.setting.themecolor.cyan': 'Циан',
  'app.setting.themecolor.green': 'Полярно-зеленый',
  'app.setting.themecolor.daybreak': 'Рассветно-синий (по умолчанию)',
  'app.setting.themecolor.geekblue': 'Гиковский синий',
  'app.setting.themecolor.purple': 'Золотисто-пурпурный',
  'app.setting.navigationmode': 'Режим навигации',
  'app.setting.sidemenu': 'Боковое меню',
  'app.setting.topmenu': 'Верхнее меню',
  'app.setting.fixedheader': 'Закрепленный заголовок',
  'app.setting.fixedsidebar': 'Закрепленная боковая панель',
  'app.setting.fixedsidebar.hint': 'Работает в режиме бокового меню',
  'app.setting.hideheader': 'Скрывать заголовок при прокрутке',
  'app.setting.hideheader.hint': 'Работает при включенном скрытии заголовка',
  'app.setting.othersettings': 'Другие настройки',
  'app.setting.weakmode': 'Режим для дальтоников',
  'app.setting.copy': 'Копировать настройки',
  'app.setting.copyinfo':
    'настройки скопированы, замените defaultSettings в src/models/setting.js',
  'app.setting.production.hint':
    'Панель настроек доступна только в режиме разработки, измените настройки вручную',
};
